<template>
  <section id="landing" v-waypoint="{ active: true, callback: onScroll, options: scrollOptions}" class="landing flex items-center justify-center">
    <background class="background" />
    <logo class="logo" />
    <scroll />
  </section>
</template>

<script>

// Modules
import { gsap } from 'gsap'

// Components
import Logo from '@/components/sections/components/logo'
import Background from '@/components/sections/components/paint-background'
import Scroll from '@/components/sections/components/scroll.vue'

export default {
  components: {
    Logo,
    Background,
    Scroll
  },
  data: () => ({
    scrollOptions: {
      root: null,
      rootMargin: '-137.5px 0px 0px 0px',
      threshold: [0.5, 0.5]
    }
  }),
  mounted () {
    gsap.fromTo('.logo', {
      autoAlpha: 0,
      scale: 0.8,
      rotateX: 50
    }, {
      autoAlpha: 1,
      scale: 1,
      rotateX: 0,
      duration: 2,
      delay: 3.5
    })
  },
  methods: {
    onScroll ({ going, direction }) {
      if (going === this.$waypointMap.GOING_IN && direction === this.$waypointMap.DIRECTION_BOTTOM) {
        gsap.to('.primary-nav', 0, {
          className: '-=primary-nav'
        })
        gsap.fromTo('.scroll', 1, {
          autoAlpha: 0,
          y: 50
        }, {
          autoAlpha: 1,
          y: 0
        })
      }
    }
  }
}

</script>

<style lang="scss" scoped>
@import "../../assets/styles/breakpoints";
.landing {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: relative;
  @include breakpoint(sm) {
    height: calc(100vh - 70px);
  }
  .logo {
    display: inline-block;
    width: 350px;
    @include breakpoint(sm) {
      width: 70%
    }
  }

  .scroll {
    position: absolute;
    left: 50%;
    bottom: 0;
  }

  .background {
    position: absolute;
    width: 75vw;
    top: -60px;
    right: -35px;
    z-index: -10;
    @include breakpoint(sm) {
      width: 130vw;
    }
  }
}
</style>
